import React, { useEffect } from 'react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WMICObjectUtil, WMICMetadataUtil } from 'wmic-pe-portals-utils-js';

import metadata from './WMICHOConstructionHeatingUpgradeComponent.metadata.json5';
import messages from './WMICHOConstructionHeatingUpgradeComponent.messages';

function WMICHOConstructionHeatingUpgradeComponent(props) {
    const { id, heatingUpgradeVM, setHeatingUpgradeVM, onValidate, showErrors, readOnly: pReadOnly } = props;

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }

        return () => {
            if (onValidate) {
                onValidate(true, id);
            }
        };
    }, [isComponentValid, onValidate, heatingUpgradeVM, id]);

    const overrideProps = {
        '@field': {
            parentNode: heatingUpgradeVM,
            readOnly: pReadOnly,
        },
    };

    const heatingUpgradeTypeChanged = (value, path) => {
        WMICObjectUtil.setAtPath(heatingUpgradeVM, path, value);
        if (WMICMetadataUtil.isVisible(heatingUpgradeVM, 'upgradeYear') === false) {
            WMICObjectUtil.setAtPath(heatingUpgradeVM, 'upgradeYear.value', undefined);
        }
        setHeatingUpgradeVM(heatingUpgradeVM);
    };

    const resolvers = {
        resolveCallbackMap: {
            heatingUpgradeTypeChanged,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={heatingUpgradeVM}
            onModelChange={setHeatingUpgradeVM}
            callbackMap={resolvers.resolveCallbackMap}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

export default WMICHOConstructionHeatingUpgradeComponent;
